import { render, staticRenderFns } from "./Clearner.vue?vue&type=template&id=5cc7253e&"
import script from "./Clearner.vue?vue&type=script&lang=js&"
export * from "./Clearner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports